<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-alert v-if="errorMessage" type="error" density="compact" closable class="mb-4" :text="errorMessage" @click:close="errorMessage = ''" />

          <!-- 店舗ごとの残数（内訳は店舗の増減履歴で確認する） -->
          <v-table density="compact" class="text-no-wrap">
            <thead>
              <tr>
                <th>{{ $t('labelStock.label.table.siteCode') }}</th>
                <th>{{ $t('labelStock.label.table.storeName') }}</th>
                <th>{{ $t('labelStock.label.table.janCode') }}</th>
                <th class="text-right">{{ $t('labelStock.label.table.remaining') }}</th>
                <th>{{ $t('labelStock.label.table.state') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in stockList" :key="s.siteCode" style="cursor: pointer;" @click="openDetail(s)">
                <td class="text-medium-emphasis" style="font-family: monospace;">{{ s.siteCode }}</td>
                <td class="font-weight-medium">{{ s.storeName }}</td>
                <td class="text-medium-emphasis" style="font-family: monospace;">{{ s.janCode }}</td>
                <td class="text-right text-subtitle-1 font-weight-bold" :class="s.remainingQty < 0 ? 'text-red-darken-1' : ''">{{ num(s.remainingQty) }}</td>
                <td>
                  <v-chip size="small" label variant="tonal" :color="remainColor(s.remainingQty)">
                    {{ $t('labelStock.label.state.' + remainState(s.remainingQty)) }}
                  </v-chip>
                </td>
                <td class="text-right text-medium-emphasis"><v-icon>mdi-chevron-right</v-icon></td>
              </tr>
              <tr v-if="!isLoading && stockList.length === 0">
                <td colspan="6" class="text-center text-medium-emphasis">
                  {{ $t('common.label.all') }} 0 {{ $t('common.label.totalCountOf') }}
                </td>
              </tr>
            </tbody>
          </v-table>
          <v-progress-linear v-if="isLoading" indeterminate color="indigo" />
        </v-container>
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import { num, remainState, remainColor } from "@/utils/labelManagement";

export default {
  components: { AppWrapperView },
  data: () => ({
    stockList: [],
    isLoading: false,
    errorMessage: "",
  }),
  mounted() {
    this.load();
  },
  methods: {
    num,
    remainState,
    remainColor,
    load() {
      this.isLoading = true;
      api.post("/label-stock/search", {})
        .then((response) => {
          if (response.data?.status == 1) {
            this.errorMessage = response.data.errorMessage;
            this.stockList = [];
            return;
          }
          this.stockList = response.data.results?.stockList ?? [];
        })
        .catch(() => {
          this.stockList = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openDetail(s) {
      router.push({ name: Paths.LABEL_STOCK_DETAIL, query: { siteCode: s.siteCode } });
    },
  },
};
</script>
